import { useEffect, useMemo, useRef } from 'react'
import type { KskCanvasCommand, KskCanvasEvent } from '@kelilearning/psycheflow-contracts/ksk'
import { renderKskCourseHtml, type KskCanvasDocument } from '@kelilearning/psycheflow-contracts/ksk-canvas'

export function KskCourseCanvas({ document, command, onEvent }: { document: KskCanvasDocument; command?: KskCanvasCommand; onEvent?: (event: KskCanvasEvent) => void }) {
  const frame = useRef<HTMLIFrameElement>(null)
  const ready = useRef(false)
  const bridgeToken = useMemo(() => `${document.courseId}:${document.courseRevision}:${crypto.randomUUID()}`, [document.courseId, document.courseRevision])
  const html = useMemo(() => renderKskCourseHtml(document, { bridgeToken }), [document, bridgeToken])
  const latest = useRef({ command, onEvent }); latest.current = { command, onEvent }
  useEffect(() => {
    ready.current = false
    const listener = (e: MessageEvent) => {
      if (e.source !== frame.current?.contentWindow || e.data?.bridgeToken !== bridgeToken || e.data?.type !== 'ksk.canvas.event' || e.data.courseId !== document.courseId || e.data.courseRevision !== document.courseRevision) return
      if (e.data.event === 'ready') {
        ready.current = true
        if (latest.current.command) frame.current?.contentWindow?.postMessage({ ...latest.current.command, bridgeToken }, '*')
      }
      latest.current.onEvent?.(e.data)
    }
    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [bridgeToken, html, document.courseId, document.courseRevision])
  useEffect(() => {
    if (ready.current && command) frame.current?.contentWindow?.postMessage({ ...command, bridgeToken }, '*')
  }, [command, bridgeToken])
  return <iframe ref={frame} title={`课程：${document.content.title}`} srcDoc={html} sandbox="allow-scripts" className="min-h-0 w-full flex-1 border-0" />
}
